<template>
  <div class="home">
    <banner-Component :list="bannerlist"></banner-Component>
    <!--      产品与方案-->
    <div class="main2 wow fadeInUp">
      <div class="two">
        <div class="title">
          <p>{{$t('home').title1}}</p>
          <p v-show="$i18n.locale==='zh-CN'">products.</p>
          <p class="big">P</p>
        </div>
        <div class="allPro">
          <swiper class="swiper" :options="swiperOption2" v-if="pList.length>1">
            <swiper-slide class="item" v-for="(item,index) in pList" :key="index">
              <div class="x" @click="gotoPro(item.id)">
                <p>{{item.title}}</p>
                <p>{{item.keywords}}</p>
                <!-- <p>{{item.ZY}}</p> -->
              </div>
              <div class="y" @click="gotoPro(item.id)">
                <!-- <p class="t">{{item.SIZE}}</p> -->
                <img :src="`http://nrell.com/${item.picurl}`" alt />
                <p class="b">
                  View
                  <br />Details
                </p>
                <i class="iconfont icon-you"></i>
              </div>
            </swiper-slide>
          </swiper>
          <div class="fa"></div>
          <div class="btn prev">
            <i class="iconfont icon-left"></i>
          </div>
          <div class="btn next">
            <i class="iconfont icon-left"></i>
          </div>
        </div>
      </div>
    </div>

    <!--      360全景-->
    <!-- <div class="title2 wow fadeInUp">
      <div class="title">
        <p>{{$t('home').title2}}</p>
        <p v-show="$i18n.locale==='zh-CN'">Product 360 display</p>
        <p class="big">P</p>
      </div>
    </div>
    <div class="info wow fadeInUp">
      <all-Component></all-Component>
    </div>-->
    <!--      越界创新-->
    <div class="cx wow fadeInUp">
      <div class="title2">
        <div class="title">
          <p>{{$t('home').title4}}</p>
          <p v-show="$i18n.locale==='zh-CN'">Cross-border innovation.</p>
          <p class="big">C</p>
        </div>
        <img class="bg" src="../assets/home/pillar-speak-naturally.png" alt />
        <div class="cxCon">
          <div class="c">
            <div class="left">
              <p>{{$t('home').con1}}</p>
            </div>
            <div class="right">
              <img class="img2" src="../assets/home1.jpg" alt="">
<!--              <div class="one">-->
<!--                <img class="cb" src="../assets/home/bigc.png" alt />-->
<!--              </div>-->
              <!--                      <div class="two">-->
              <!--                          <img src="../assets/home/cc2.png" alt="">-->
              <!--                      </div>-->
              <!--                      <div class="three">-->
              <!--                          <img src="../assets/home/cc3.png" alt="">-->
              <!--                      </div>-->
<!--              <div class="allC" :class="{'eallc':$i18n.locale==='en'}">-->
<!--                <div class="yz">-->
<!--                  <img src="../assets/home/yz.png" alt />-->
<!--                  <p>{{$t('home').four[0]}}</p>-->
<!--                </div>-->
<!--                <div class="gx">-->
<!--                  <img src="../assets/home/gx.png" alt />-->
<!--                  <p>{{$t('home').four[1]}}</p>-->
<!--                </div>-->
<!--                <div class="dt">-->
<!--                  <img src="../assets/home/dt.png" alt />-->
<!--                  <p>{{$t('home').four[2]}}</p>-->
<!--                </div>-->
<!--                <div class="long">-->
<!--                  <img src="../assets/home/tc.png" alt />-->
<!--                  <div class="lx" :class="{'elx':$i18n.locale==='en'}">-->
<!--                    <img src="../assets/home/lx.png" alt />-->
<!--                    <p>{{$t('home').four[3]}}</p>-->
<!--                  </div>-->

<!--                  <img class="cl" src="../assets/amt_logow.png" alt />-->
<!--                </div>-->
<!--              </div>-->
            </div>
          </div>
        </div>
      </div>
      <div class="wave">
        <div class="water water1"></div>
        <div class="water water2"></div>
        <div class="water water2"></div>
      </div>
    </div>
    <!--      地图-->
    <div class="main">
      <div class="mainCon">
        <div class="w">
          <div class="one">
            <div class="left">
              <img class="img2" src="../assets/home2.jpg" alt="">
            </div>
            <div class="right">
              <div class="title">
                <p :class="{'et':$i18n.locale==='en'}">{{$t('home').title0}}</p>
                <p v-show="$i18n.locale==='zh-CN'">ABOUT US</p>
                <p class="big">A</p>
              </div>
              <p class="content" v-html="$t('home').con0"></p>
              <div class="btn" @click="goAbout">
                <btn-Component></btn-Component>
              </div>
            </div>
            <div class="threeText" ref="counts">
              <div class="item">
                <div class="t">
                  <span id="num1">10</span>
                  <span style="line-height: 10px;">+</span>
                </div>
                <span class="small">{{$t('home').three[0]}}</span>
              </div>
              <div class="item">
                <div class="t">
                  <span id="num2">10</span>
                  <span style="line-height: 10px;">+</span>
                </div>
                <span class="small">{{$t('home').three[1]}}</span>
              </div>
              <div class="item">
                <div class="t">
                  <span id="num3">10</span>
                  <span style="line-height: 10px;">+</span>
                </div>
                <span class="small">{{$t('home').three[2]}}</span>
              </div>
              <div class="item">
                <div class="t">
                  <span id="num4">5000</span>
                  <span style="line-height: 10px;">㎡</span>
                </div>
                <span class="small">{{$t('home').three[3]}}</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!--      新闻媒体-->
    <div class="title2 title3 wow fadeInUp">
      <div class="title">
        <p>{{$t('home').title3}}</p>
        <p v-show="$i18n.locale==='zh-CN'">news</p>
        <p class="big">N</p>
      </div>
    </div>
    <div class="news wow fadeInUp">
      <div class="title2 title3 title4 wow fadeInUp">
        <div class="title">
          <p>{{$t('home').title3}}</p>
          <p v-show="$i18n.locale==='zh-CN'">news</p>
          <p class="big">N</p>
        </div>
      </div>
      <div class="newsCon">
        <swiper class="swiper" :options="swiperOption3" v-if="nList.length>1">
          <swiper-slide class="item" v-for="(item,index) in nList" :key="index">
            <div class="left" @click="gotoNews(item.id)">
              <img :src="`http://nrell.com/${item.picurl}`" alt />
            </div>
            <div class="right" @click="gotoNews(item.id)">
              <p>{{item.title}}</p>
              <p>{{item.posttime}}</p>
              <p>{{item.description}}</p>
              <p>- more -</p>
            </div>
          </swiper-slide>
        </swiper>
        <div class="fa">
          <p>news.</p>
        </div>
        <div class="btn prev">
          <i class="iconfont icon-left"></i>
        </div>
        <div class="btn next">
          <i class="iconfont icon-left"></i>
        </div>
      </div>
    </div>

    <foot-Component></foot-Component>
  </div>
</template>

<script>
import bannerComponent from "../components/banner";
import btnComponent from "../components/btn";
import mapComponent from "../components/map";
import allComponent from "../components/allInfo";
import { swiper, swiperSlide } from "vue-awesome-swiper";
import "swiper/dist/css/swiper.css";
import Scrollbar from "smooth-scrollbar";
import footComponent from "../components/foot";
import "../common/jquery-1.11.3.min";
import { CountUp } from "countup.js";
import { getHomeInfo } from "../util/lang";
export default {
  data() {
    return {
      bannerlist: [],
      pList: [],
      swiperOption2: {
        effect: "fade",
        loop: true,
        autoplay: false,
        navigation: {
          prevEl: ".allPro .btn.prev",
          nextEl: ".allPro .btn.next",
        },
      },
      swiperOption3: {
        speed: 2000,
        loop: true,
        autoplay: false,
        navigation: {
          prevEl: ".news .btn.prev",
          nextEl: ".news .btn.next",
        },
      },
      nList: [],
    };
  },
  mounted() {
    Scrollbar.initAll(document.getElementById("scroller-wrapper"));
    let scrollbar = Scrollbar.get(document.getElementById("scroller-wrapper"));
    scrollbar.scrollTo(0, 0);
    localStorage.setItem("index", "0");
    this.count();
    this.$nextTick(() => {
      this.getIndex();
    });

    // if (this.$i18n.locale === "en") {
    //   this.getNews("30");
    //   this.getProducts("43");
    // } else {
    //   this.getNews("25");
    //   this.getProducts("42");
    // }
    this.scrollbar = Scrollbar.init(
      document.getElementById("scroller-wrapper")
    );
    window.pageYOffset = this.scrollbar.scrollTop;
    window.pageYOffset = this.scrollbar.scrollTop;
    this.scrollbar.addListener(() => {
      $(".main div").each(function () {
        var _this = $(this);
        if (
          $(window).scrollTop() >=
          $(this).offset().top - $(window).height() + 50
        ) {
          _this.addClass("show");
        } else {
          _this.removeClass("show");
        }
      });
      window.pageYOffset = this.scrollbar.scrollTop;
    });
  },
  components: {
    allComponent,
    bannerComponent,
    btnComponent,
    footComponent,
    mapComponent,
    swiper,
    swiperSlide,
  },
  methods: {
    getIndex() {
      const url = `${getHomeInfo()}`;
      this.$axios.get(url).then((res) => {
        this.bannerlist = res.data.banner;
        this.pList=res.data.product
        this.nList=res.data.news
      });
    },
    gotoNews(id) {
      const link = `/newsInfo.html?nid=${id}`;
      window.open(link, "_blank");
    },
    gotoPro(id) {
      const link = `/proInfo.html?pid=${id}`;
      window.open(link);
    },
    goAbout() {
      const link = `/about.html`;
      window.open(link);
    },
    count() {
      let element = this.$refs.counts;
      let actualTop = element.offsetTop;
      let current = element.offsetParent;
      while ((element = element.offsetParent)) {
        actualTop += element.offsetTop;
        /* current = current.offsetParent; */
      }
      let demoFi1 = new CountUp("num1", 10);
      let demoFi2 = new CountUp("num2", 10);
      let demoFi3 = new CountUp("num3", 10);
      let demoFi4 = new CountUp("num4", 5000);
      let numok = false;
      let scrollbar = Scrollbar.get(
        document.getElementById("scroller-wrapper")
      );
      if (scrollbar) {
        scrollbar.addListener((status) => {
          if (!numok) {
            if (actualTop < status.offset.y + document.body.clientHeight) {
              demoFi1.start();
              demoFi2.start();
              demoFi3.start();
              demoFi4.start();
              numok = true;
            }
          }
        });
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.home {
  width: 100%;
  overflow: hidden;
  .main {
    width: 100%;
    .mainCon {
      width: 100%;
      .w {
        width: 100%;
        background-color: #ebebeb;
        .one {
          width: 1280px;
          margin: 0 auto;
          display: flex;
          flex-direction: row;
          flex-wrap: wrap;
          padding-bottom: 60px;
          align-items: center;
          .left {
            width: 55%;
            overflow: hidden;
             img{
               width: 100%;
               display: block;
               object-fit: cover;
               margin-top: 60px;
               cursor: pointer;
               transition: all 600ms;
             }
            &:hover{
              img{
                transform: scale(1.05);
              }
            }
          }
          .right {
            width: 40%;
            margin-left: 5%;
            padding-top: 200px;
            .title {
              width: 100%;
              height: 60px;
              position: relative;
              p:nth-child(1) {
                font-size: 28px;
                z-index: 100;
                position: absolute;
                left: 10px;
                top: -40%;
              }
              .et {
                top: -30% !important;
              }
              p:nth-child(2) {
                color: #8c8c8c;
                font-size: 20px;
                padding: 5px 0;
                z-index: 100;
                position: absolute;
                left: 10px;
                bottom: 10px;
              }
              .big {
                position: absolute;
                bottom: -60%;
                left: 10px;
                color: #dedede;
                width: 100%;
                font-size: 150px;
                font-family: "os";
              }
            }
            .title::before {
              position: absolute;
              display: inline-block;
              content: "";
              height: 23px;
              width: 2px;
              background-color: #f7bc30;
              top: -22%;
              left: 0;
            }
            .content {
              color: #414141;
              line-height: 40px;
              margin-top: 10px;
              font-size: 15px;
              font-family: "Fira Code Medium";
            }
            .btn {
              float: right;
            }
          }
          .threeText {
            width: 80%;
            margin-left: 10%;
            display: flex;
            flex-direction: row;
            justify-content: space-between;
            font-family: "os";
            margin-top: 60px;
            .item {
              display: flex;
              flex-direction: column;
              text-align: center;
              .t {
                position: relative;
                padding-right: 10px;
                padding-left: 10px;
                padding-bottom: 10px;
                span:first-child {
                  font-size: 40px;
                  color: #0673da;
                  font-weight: bolder;
                }
                span:last-child {
                  position: absolute;
                  top: -5px;
                  right: -20px;
                  font-size: 20px;
                  color: #0673da;
                  font-weight: bolder;
                }
              }
              .small {
                font-size: 14px;
                color: #444546;
              }
            }
          }
        }
      }
    }
    div {
      opacity: 0;
      transition: all 2s;
    }
    .show {
      opacity: 1;
      .name {
        width: 90%;
        margin-left: 5%;
        padding: 10px 0;
        border-top: 1px solid #dcdcdc;
        text-align: center;
        font-size: 18px;
        font-weight: bolder;
        text-transform: uppercase;
      }
    }
  }
  .main2 {
    width: 100%;
    .two {
      width: 90%;
      margin-left: 10%;
      padding: 120px 0;
      .title {
        width: 1280px;
        height: 60px;
        position: relative;
        margin: 30px auto;
        p:nth-child(1) {
          font-size: 28px;
          z-index: 100;
          position: absolute;
          left: 10px;
          top: -40%;
        }
        p:nth-child(2) {
          color: #8c8c8c;
          font-size: 20px;
          padding: 5px 0;
          z-index: 100;
          position: absolute;
          left: 10px;
          bottom: 10px;
          text-transform: uppercase;
        }
        .big {
          position: absolute;
          bottom: -60%;
          left: 10px;
          color: rgba(0, 0, 0, 0.05);
          width: 100%;
          font-size: 150px;
          font-family: "os";
        }
      }
      .title::before {
        position: absolute;
        display: inline-block;
        content: "";
        height: 23px;
        width: 2px;
        background-color: #f7bc30;
        top: -22%;
        left: 0;
      }
      .allPro {
        width: 87%;
        // margin-left: 13%;
        position: relative;
        .fa {
          width: 100%;
          background-color: #e5e8ec;
          padding: 80px 20px;
          height: 300px;
          position: absolute;
          left: 0;
          bottom: 0;
          z-index: 10;
        }
        .swiper {
          width: 100%;
          z-index: 100;
          .item {
            position: relative;
            height: 600px;
            cursor: pointer;
            .x {
              width: 100%;
              padding: 80px 20px;
              height: 300px;
              position: absolute;
              left: 0;
              bottom: 0;
              p {
                margin-left: 5%;
                line-height: 50px;
              }
              p:nth-child(1) {
                font-size: 35px;
                font-family: "Fira Code Medium";
                font-weight: bolder;
              }
              p:nth-child(2) {
                font-size: 20px;
                font-family: "Fira Code Medium";
                font-weight: lighter;
                width: 50%;
              }
              p:nth-child(3) {
                width: 30%;
                padding: 30px 0;
                display: -webkit-box;
                -webkit-box-orient: vertical;
                -webkit-line-clamp: 2;
                overflow: hidden;
                height: 55px;
              }
            }
            .y {
              position: absolute;
              top: 0;
              right: 2%;
              width: 36%;
              img {
                width: 100%;
                object-fit: cover;
              }
              .t {
                width: 100%;
                text-align: right;
                position: absolute;
                top: 5%;
                font-size: 25px;
                right: 5%;
                color: rgba(255, 255, 255, 0.5);
              }
              .b {
                width: 100%;
                position: absolute;
                bottom: 5%;
                left: 5%;
                line-height: 30px;
                font-size: 25px;
                color: white;
              }
              i {
                color: white;
                font-size: 30px;
                position: absolute;
                left: 50%;
                bottom: 5%;
                transition: all 2s;
              }
            }
            .y::before {
              position: absolute;
              left: 0;
              top: 0;
              width: 100%;
              height: 100%;
              background-color: rgba(0, 131, 255, 0.5);
              opacity: 0;
              display: inline-block;
              content: "";
              transition: all 2s;
            }
            .y:hover {
              i {
                color: #f5ac01;
              }
            }
            .y:hover::before {
              opacity: 1;
            }
          }
          .swiper-slide {
            opacity: 0 !important;
            transition: all 1.5s !important;
          }
          .swiper-slide-active {
            opacity: 1 !important;
          }
        }
        .prev {
          position: absolute;
          bottom: 10%;
          left: 7%;
          color: #0673da;
          padding: 5px 5px;
          cursor: pointer;
          transition: all 2s;
          z-index: 1000;
          i {
            font-size: 40px;
          }
        }
        .next {
          position: absolute;
          bottom: 10%;
          left: 14%;
          color: #0673da;
          transform: rotate(180deg);
          padding: 5px 5px;
          cursor: pointer;
          transition: all 2s;
          z-index: 1000;
          i {
            font-size: 40px;
          }
        }
        .btn:hover {
          color: #f5ac01;
        }
        .btn:focus {
          outline: none;
        }
      }
    }
  }
  .title2 {
    width: 90%;
    margin-left: 10%;
    margin-top: 60px;
    .title {
      width: 1280px;
      height: 60px;
      position: relative;
      margin: 30px auto;
      p:nth-child(1) {
        font-size: 28px;
        z-index: 100;
        position: absolute;
        left: 10px;
        top: -40%;
      }
      p:nth-child(2) {
        color: #8c8c8c;
        font-size: 20px;
        padding: 5px 0;
        z-index: 100;
        position: absolute;
        left: 10px;
        bottom: 10px;
        text-transform: uppercase;
      }
      .big {
        position: absolute;
        bottom: -60%;
        left: 10px;
        color: rgba(0, 0, 0, 0.05);
        width: 100%;
        font-size: 150px;
        font-family: "os";
      }
    }
    .title::before {
      position: absolute;
      display: inline-block;
      content: "";
      height: 23px;
      width: 2px;
      background-color: #f7bc30;
      top: -22%;
      left: 0;
    }
  }
  .info {
    width: 1000px;
    margin: 60px auto;
    height: 600px;
    padding-bottom: 60px;
  }
  .title3 {
    margin-top: 160px;
    z-index: 1000;
    .title {
      p {
        color: white;
      }
      .big {
        z-index: 100;
        color: rgba(255, 255, 255, 0.1);
      }
    }
    .title::before {
      z-index: 100;
    }
  }
  .news {
    width: 100%;
    margin: 0 auto;
    position: relative;
    margin-top: -250px;
    .title4 {
      display: none;
    }
    .newsCon {
      width: 100%;
      position: relative;
      z-index: 10;
      .swiper {
        width: 100%;
        height: 600px;
        z-index: 1000;
        .item {
          width: 100%;
          display: flex;
          flex-direction: row;
          cursor: pointer;
          .left {
            width: 100%;
            img {
              width: 100%;
              object-fit: cover;
              height: 100%;
            }
          }
          .right {
            padding: 120px 80px;
            p {
              color: white;
              padding: 20px 0;
            }
            p:nth-child(1) {
              font-family: "Fira Code Medium";
              font-weight: lighter;
              font-size: 20px;
            }
            p:nth-child(2) {
              font-family: helve;
              font-size: 14px;
              padding-bottom: 40px;
              border-bottom: 1px solid rgba(255, 255, 255, 0.2);
            }
            p:nth-child(3) {
              font-size: 14px;
              font-family: "Fira Code Medium";
              font-weight: lighter;
              line-height: 30px;
            }
            p:nth-child(4) {
              font-family: "Fira Code Medium";
              font-weight: lighter;
              font-size: 14px;
              text-align: right;
              text-transform: uppercase;
            }
          }
        }
        .swiper-slide {
          .left {
            margin-top: 600px;
            transition: all 2s;
            animation-delay: 2s;
          }
        }
        .swiper-slide-active {
          .left {
            margin-top: 0;
          }
        }
      }
      .fa {
        position: absolute;
        right: 0;
        top: 0;
        width: 100%;
        z-index: 100;
        height: 600px;
        background-color: #046acb;
        p {
          color: rgba(255, 255, 255, 0.05);
          font-size: 200px;
          font-family: os;
          position: absolute;
          right: 0;
          top: 0;
          -webkit-writing-mode: vertical-rl;
          writing-mode: vertical-rl;
          text-transform: uppercase;
        }
      }
      .prev {
        position: absolute;
        bottom: 10%;
        right: 14%;
        color: white;
        padding: 5px 5px;
        cursor: pointer;
        transition: all 2s;
        z-index: 1000;
        i {
          font-size: 40px;
        }
      }
      .next {
        position: absolute;
        bottom: 10%;
        right: 7%;
        color: white;
        padding: 5px 5px;
        transform: rotate(180deg);
        cursor: pointer;
        transition: all 2s;
        z-index: 1000;
        i {
          font-size: 40px;
        }
      }
      .btn:hover {
        color: #f5ac01;
      }
      .btn:focus {
        outline: none;
      }
    }
  }
  .cx {
    width: 100%;
    background-color: #f1f1f1;
    padding: 60px 0;
    padding-bottom: 0;
    position: relative;
    .bg {
      width: 60%;
      object-fit: cover;
      padding-top: 300px;
    }
    .cxCon {
      width: 100%;
      position: absolute;
      left: 0;
      top: 30%;
      .c {
        width: 1280px;
        margin: 0 auto;
        display: flex;
        flex-direction: row;
        justify-content: space-between;
        .left {
          width: 40%;
          margin-left: 8%;
          padding-top: 80px;
          line-height: 35px;
          p {
            font-family: "Fira Code Medium";
            font-weight: lighter;
          }
        }
        .right {
          width:45%;
          position: relative;
          padding-bottom: 60px;
          height:400px;
          overflow: hidden;
          .img2{
            width:100%;
            height:100%;
            display: block;
            object-fit: cover;
            cursor: pointer;
            transition: all 600ms;
            &:hover{
              transform: scale(1.05);
            }
          }
          .one {
            position: absolute;
            width: 80%;
            left: 12%;
            top: -15%;
            height: 480px;
            /*border: 1px dashed #888888;*/
            .bg {
              width: 100%;
              object-fit: cover;
              height: 100%;
            }
          }
          .two {
            position: absolute;
            width: 80%;
            left: 16%;
            top: -9%;
            height: 480px;
            /*border: 1px dashed #888888;*/
            img {
              width: 100%;
              object-fit: cover;
              height: 100%;
            }
          }
          .three {
            position: absolute;
            width: 80%;
            left: 17%;
            top: -8%;
            height: 480px;
            /*border: 1px dashed #888888;*/
            img {
              width: 100%;
              object-fit: cover;
              height: 100%;
            }
          }
          .allC {
            position: absolute;
            left: 25%;
            width: 50%;
            height: 80%;
            top: -5%;
            cursor: pointer;
            p {
              font-family: "Fira Code Medium";
              font-weight: bolder;
              font-size: 15px;
            }
            .yz {
              height: 130px;
              width: 130px;
              border-radius: 50%;
              background-color: rgba(73, 73, 73, 0.13);
              text-align: center;
              position: absolute;
              left: 8%;
              top: 25%;
              cursor: pointer;
              transition: all 2s;
              img {
                margin-top: 30px;
              }
            }
            .gx {
              height: 130px;
              width: 130px;
              border-radius: 50%;
              background-color: rgba(73, 73, 73, 0.13);
              text-align: center;
              position: absolute;
              left: 40%;
              top: 3%;
              cursor: pointer;
              transition: all 2s;
              img {
                margin-top: 30px;
              }
            }
            .dt {
              height: 130px;
              width: 130px;
              border-radius: 50%;
              background-color: rgba(73, 73, 73, 0.13);
              text-align: center;
              position: absolute;
              transition: all 2s;
              left: 72%;
              top: 25%;
              cursor: pointer;
              img {
                margin-top: 30px;
              }
            }
            .yz,
            .gx,
            .dt {
              p,
              img {
                transition: all 2s;
              }
            }
            .long {
              position: absolute;
              left: 40%;
              bottom: 0;
              .lx {
                position: absolute;
                top: 12%;
                left: 38%;
              }
              .elx {
                p {
                  margin-left: -10px;
                }
              }
              .cl {
                position: absolute;
                bottom: 19%;
                width: 60px;
                left: 30%;
              }
            }
          }
          .eallc {
            p {
              font-size: 12px;
            }
          }
          .allC:hover {
            .yz,
            .gx,
            .dt {
              background-color: #0c3665;
              img {
                transform: rotateY(180deg);
              }
              p {
                color: white;
              }
            }
          }
        }
      }
    }
    .wave {
      position: absolute;
      left: 0;
      bottom: 0;
      width: 100%;
      height: 110px;
      overflow: hidden;
      .water {
        position: absolute;
        width: 200%;
        height: 100%;
        background-size: 50% 100%;
        background-image: url(../assets/home/wave2.png);
      }
      .water1 {
        top: 20px;
        left: -100%;
        opacity: 0.2;
        animation: water-right 20s infinite linear;
      }
      .water2 {
        top: 30px;
        left: 0;
        opacity: 0.3;
        animation: water-left 30s infinite linear;
      }
      .water3 {
        top: 44px;
        left: -100%;
        animation: water-right 40s infinite linear;
      }
      @keyframes water-right {
        0% {
          transform: translateX(0) translateZ(0) scaleY(1);
        }

        50% {
          transform: translateX(25%) translateZ(0) scaleY(0.85);
        }
        100% {
          transform: translateX(50%) translateZ(0) scaleY(1);
        }
      }
      @keyframes water-left {
        0% {
          transform: translate(0%, 0px);
        }
        100% {
          transform: translate(-50%, 0px);
        }
      }
    }
  }
  @media screen and (min-width: 2000px) {
    .main2 {
      .two {
        .allPro {
          .swiper {
            .item {
              .y {
                height: 600px;
              }
            }
          }
        }
      }
    }
  }
  @media screen and (max-width: 1680px) {
    .main2 {
      .two {
        .allPro {
          margin-left: 8%;
          width: 92%;
          .swiper {
            .item {
              .x {
                p:nth-child(1) {
                  width: 50%;
                }
              }
            }
          }
        }
      }
    }
    .cx {
      .bg {
        height: 550px;
      }
    }
  }
  @media screen and (max-width: 1440px) {
    .main2 {
      .two {
        .allPro {
          .swiper {
            .item {
              .x {
                p:nth-child(1) {
                  width: 50%;
                  font-size: 30px;
                }
              }
            }
          }
        }
      }
    }
    .cx {
      .bg {
        height: 550px;
      }
    }
  }
  @media screen and (max-width: 450px) {
    .main {
      .mainCon {
        .w {
          .one {
            width: 95%;
            flex-direction: column;
            .left {
              width: 100%;
              padding: 30px 0;
              .a {
                display: none;
              }
              .b {
                display: inline-block;
                width: 100%;
                object-fit: cover;
              }
            }
            .right {
              width: 100%;
              margin-left: 0;
              padding-top: 0;
            }
            .threeText {
              width: 100%;
              margin-left: 0;
              flex-wrap: wrap;
              .item {
                width: 50%;
                margin-top: 10px;
                .t {
                  span:last-child {
                    right: auto;
                    top: 0;
                  }
                }
              }
            }
          }
        }
      }
    }
    .main2 {
      .two {
        margin-left: 5%;
        padding: 60px 0;
        .title {
          width: 100%;
          p:nth-child(1) {
            font-size: 22px;
            top: -26%;
          }
        }
        .allPro {
          width: 100%;
          margin-left: 0;
          .swiper {
            .item {
              height: 522px;
              .x {
                padding: 0 0;
                bottom: 20px;
                height: 208px;
                p {
                  width: 80%;
                  line-height: 40px;
                }
                p:nth-child(1) {
                  font-size: 19px;
                  width: 90%;
                }
                p:nth-child(2) {
                  font-size: 16px;
                  width: 90%;
                }
                p:nth-child(3) {
                  width: 80%;
                  margin-left: 5%;
                  padding: 10px 0;
                  height: 78px;
                }
              }
              .y {
                width: 100%;
                right: 0;
                img{
                  height:287px;
                }
              }
            }
          }
          .fa {
            height: 400px;
            padding: 0;
          }
          .prev,
          .next {
            bottom: 2%;
            -webkit-tap-highlight-color: rgba(255, 255, 255, 0);
          }
          .next {
            right: 10%;
          }
        }
      }
    }
    .info {
      width: 95%;
      height: 350px;
    }
    .title2 {
      margin-left: 2.5%;
      .title {
        width: 100%;
        p:nth-child(1) {
          font-size: 22px;
          top: -26%;
        }
      }
    }
    .news {
      margin-top: 0;
      .title4 {
        display: inline-block;
        margin-top: 0;
        position: absolute;
        left: 2.5%;
        top: 60px;
      }
      .newsCon {
        .swiper {
          .item {
            flex-direction: column;
            .right {
              padding: 10px 10px;
              p:nth-child(1) {
                font-size: 18px;
              }
              p:nth-child(2),
              p:nth-child(1) {
                padding: 10px 0;
              }
              p:nth-child(3) {
                display: -webkit-box;
                -webkit-box-orient: vertical;
                -webkit-line-clamp: 3;
                overflow: hidden;
                height: 90px;
                padding: 5px 0;
              }
            }
          }
        }
        .prev {
          right: 52%;
          bottom: 3%;
          -webkit-tap-highlight-color: rgba(255, 255, 255, 0);
        }
        .next {
          bottom: 3%;
          right: 38%;
          -webkit-tap-highlight-color: rgba(255, 255, 255, 0);
        }
      }
    }
    .title3 {
      display: none;
    }
    .cx {
      height: 800px;
      .bg {
        height: 200px;
        padding-top: 450px;
      }
      .cxCon {
        top: 15%;
        .c {
          width: 95%;
          flex-direction: column;
          .left {
            width: 100%;
            margin-left: 0;
            p {
              display: -webkit-box;
              -webkit-box-orient: vertical;
              -webkit-line-clamp: 4;
              overflow: hidden;
              font-size: 14px;
              height: 140px;
            }
          }
          .right {
            width: 100%;
            .one {
              width: 90%;
              left: 5%;
              img {
                width: 100%;
                height: 450px;
                object-fit: contain;
              }
            }
            .allC {
              width: 80%;
              left: 0;
              top: 0;
            }
          }
        }
      }
      .wave {
        .water {
          background-size: cover;
        }
      }
    }
  }
}
</style>
